import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import React from "react";
import { HiX } from "react-icons/hi";
import { LuChevronDown } from "react-icons/lu";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown";
import { useCommunication } from "@/contexts/chat-provider";
import { formatName } from "@/lib/format-data";
import { ChatWindowState } from "@/types/chat";
import { ChatStatus } from "@/types/enums/chat";
import { chatQueryOptions } from "@/query/comms/chat";
interface HiddenChatsDropdownProps {
  chats: ChatWindowState[];
}
const ChatItem = t0 => {
  const $ = _c(29);
  const {
    chat
  } = t0;
  const {
    openChat,
    closeChat
  } = useCommunication();
  let t1;
  if ($[0] !== chat.chatId) {
    t1 = chatQueryOptions.detail(chat.chatId ?? "");
    $[0] = chat.chatId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = !!chat.chatId;
  let t3;
  if ($[2] !== t1 || $[3] !== t2) {
    t3 = {
      ...t1,
      enabled: t2
    };
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const {
    data: chatDetail
  } = useQuery(t3);
  let t4;
  if ($[5] !== chatDetail?.patients || $[6] !== chatDetail?.primaryPatientId) {
    t4 = chatDetail?.primaryPatientId ? chatDetail?.patients.find(patient => patient.id === chatDetail?.primaryPatientId) : chatDetail?.patients[0];
    $[5] = chatDetail?.patients;
    $[6] = chatDetail?.primaryPatientId;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const primaryPatient = t4;
  if (!primaryPatient) {
    let t5;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <span className="truncate text-body text-foreground-muted">Loading…</span>;
      $[8] = t5;
    } else {
      t5 = $[8];
    }
    let t6;
    if ($[9] !== chat || $[10] !== closeChat) {
      t6 = e_0 => {
        e_0.stopPropagation();
        closeChat(chat);
      };
      $[9] = chat;
      $[10] = closeChat;
      $[11] = t6;
    } else {
      t6 = $[11];
    }
    let t7;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = <HiX className="h-4 w-4" />;
      $[12] = t7;
    } else {
      t7 = $[12];
    }
    let t8;
    if ($[13] !== t6) {
      t8 = <DropdownMenuItem onSelect={_temp} className="flex w-full items-center justify-between">{t5}<button onClick={t6} className="p-1 text-foreground-muted hover:text-foreground-secondary" aria-label="Close chat">{t7}</button></DropdownMenuItem>;
      $[13] = t6;
      $[14] = t8;
    } else {
      t8 = $[14];
    }
    return t8;
  }
  let t5;
  if ($[15] !== openChat || $[16] !== primaryPatient.id) {
    t5 = () => openChat(primaryPatient.id);
    $[15] = openChat;
    $[16] = primaryPatient.id;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[18] !== primaryPatient.firstName || $[19] !== primaryPatient.lastName) {
    t6 = formatName(primaryPatient.firstName, primaryPatient.lastName);
    $[18] = primaryPatient.firstName;
    $[19] = primaryPatient.lastName;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  let t7;
  if ($[21] !== t6) {
    t7 = <span className="truncate text-body">{t6}</span>;
    $[21] = t6;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  let t8;
  if ($[23] !== chatDetail?.status) {
    t8 = chatDetail?.status === ChatStatus.UNREAD && <span className="flex h-2 w-2 rounded-full bg-red-500" />;
    $[23] = chatDetail?.status;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  let t9;
  if ($[25] !== t5 || $[26] !== t7 || $[27] !== t8) {
    t9 = <DropdownMenuItem className="flex w-full items-center justify-between" onClick={t5}>{t7}{t8}</DropdownMenuItem>;
    $[25] = t5;
    $[26] = t7;
    $[27] = t8;
    $[28] = t9;
  } else {
    t9 = $[28];
  }
  return t9;
};
const HiddenChatsDropdown: React.FC<HiddenChatsDropdownProps> = t0 => {
  const $ = _c(15);
  const {
    chats
  } = t0;
  const t1 = chats.length === 1 ? "chat" : "chats";
  let t2;
  if ($[0] !== t1) {
    t2 = <span>{t1}</span>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== chats.length || $[3] !== t2) {
    t3 = <span>+ {chats.length}{" "}{t2}</span>;
    $[2] = chats.length;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <LuChevronDown className="h-5 w-5 text-foreground-secondary transition-transform duration-200 group-data-[state=open]:rotate-180" />;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3) {
    t5 = <DropdownMenuTrigger asChild={true}><button className="group flex h-11 items-center gap-2 rounded-t-lg border bg-background-secondary px-3 py-2 text-body-strong text-foreground shadow-lg">{t3}{t4}</button></DropdownMenuTrigger>;
    $[6] = t3;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== chats) {
    t6 = chats.map(_temp2);
    $[8] = chats;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t6) {
    t7 = <DropdownMenuContent align="end" className="w-56">{t6}</DropdownMenuContent>;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t5 || $[13] !== t7) {
    t8 = <DropdownMenu>{t5}{t7}</DropdownMenu>;
    $[12] = t5;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
};
export default HiddenChatsDropdown;
function _temp(e) {
  return e.preventDefault();
}
function _temp2(chat, index) {
  return <ChatItem key={chat.chatId || `placeholder-${index}`} chat={chat} />;
}